import styled, { css } from 'styled-components';
import { color, layout, space, typography } from 'styled-system';
import { rgba } from 'utils/polished';

import IconStyles from './iconStyles';

const ButtonStyles = styled.button`
  ${color}
  ${space}
  ${layout}
  ${typography}

  font-weight: bold;
  flex-shrink: 0;
  outline: none !important;
  height: ${props => props.theme.buttonSize.normal};

  @media screen and (max-width: 575px) {
    font-size: ${props => props.theme.fontSize[4]};
  }

  ${props =>
    props.fullWidth !== undefined &&
    css`
      display: block;
      width: 100%;
    `}

  ${props =>
    props.width !== undefined &&
    css`
      width: ${props.width}px;
    `}

  ${props =>
    props.large !== undefined &&
    css`
      height: ${props.theme.buttonSize.large};
    `}

  ${props =>
    props.circular === undefined &&
    css`
      ${props.p === undefined &&
      css`
        padding: 0 ${props.theme.space[2]};
      `};

      ${IconStyles} {
        margin-right: 4px;
      }
    `};

  ${props =>
    props.circular !== undefined &&
    css`
      ${props.backgroundColor === undefined &&
      css`
        background-color: ${props.theme.colors.white};
      `}

      box-shadow: ${props.theme.boxShadowButton};
      border-radius: 50%;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      width: ${props.theme.buttonSize.normal};
      height: ${props.theme.buttonSize.normal};

      ${props.large &&
      css`
        width: ${props.theme.buttonSize.large};
        height: ${props.theme.buttonSize.large};
      `};

      ${!props.noHover &&
      css`
        &:hover {
          background-color: ${props.theme.colors.primary};
          &,
          ${IconStyles} {
            color: ${props.theme.colors.white};
          }
        }
      `}
    `};

  ${props =>
    props.variant === 'primary' &&
    css`
      color: ${props.theme.colors.white};
      background: ${props.theme.colors.primary};

      &:hover {
        color: ${props.theme.colors.primary};
        background: ${rgba(props.theme.colors.primary, 0.16)};
      }
    `};

  ${props =>
    props.variant === 'secondary' &&
    css`
      color: ${props.theme.colors.primary};
      background: ${rgba(props.theme.colors.primary, 0.16)};

      &:hover {
        color: ${props.theme.colors.white};
        background: ${props.theme.colors.primary};
      }
    `};

  ${props =>
    props.variant === 'tertiary' &&
    css`
      color: ${props.theme.colors.white};

      ${props.active === true &&
      css`
        background-color: ${props.theme.colors.buttonSelected};
      `};

      &:hover {
        background-color: ${props.theme.colors.buttonSelected};
      }
    `};

  ${props =>
    props.variant === 'inverse' &&
    css`
      border: 0.0625rem solid ${rgba(props.theme.colors.white, 0.1)};
      color: ${props.theme.colors.primary};
      background-color: ${props.theme.colors.white};

      &:hover {
        color: ${props.theme.colors.white};
        background-color: ${props.theme.colors.primary};
      }
    `};

  ${props =>
    props.outline &&
    css`
      border: 0.0625rem solid ${props.theme.colors.separator};
      background: transparent;
      box-shadow: none;

      &:hover {
        background-color: ${props.theme.colors.primary};
        border-color: ${props.theme.colors.primary};
        ${IconStyles} {
          color: ${props.theme.colors.white};
        }
      }
    `};

  ${props =>
    props.square !== undefined &&
    css`
      width: 1.375rem;
      height: 1.375rem;
      border-radius: 0.3125rem;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 0;

      ${IconStyles} {
        margin-right: 0;
      }
    `};

  ${props =>
    props.disabled === true &&
    css`
      color: ${props.theme.colors.white};
      background: ${props.theme.colors.gray};
      ${IconStyles} {
        color: ${props.theme.colors.white};
      }

      &:hover {
        color: ${props.theme.colors.white};
        background: ${rgba(props.theme.colors.gray, 0.16)};
        border-color: ${rgba(props.theme.colors.gray, 0.16)};
        ${IconStyles} {
          color: ${props.theme.colors.white};
        }
      }
    `};
`;

export default ButtonStyles;
